import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachOnboardingProcessThunk } from "../redux/Slices/onboardingSlice";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";

const StripeCoachOnboard = () => {
  const dispatch = useDispatch();
  const {
    coachOnboardingProcess,
    loadingOnboardingProcess,
    onboardingProcessError,
  } = useSelector((state) => state.onboarding);

  const { offerID } = useParams();

  // Call the API once when navigating to this page
  useEffect(() => {
    if (offerID) {
      dispatch(fetchCoachOnboardingProcessThunk({ offerID }));
    }
  }, [dispatch, offerID]);

  const type = coachOnboardingProcess?.type;
  // const type = "failed";
  const url = coachOnboardingProcess?.url;

  const handleRedirect = () => {
    if (url) {
      window.location.href = url;
    }
  };

  const renderContent = () => {
    // Loading state
    if (loadingOnboardingProcess) {
      return (
        <div className=" formContainer d-flex justify-content-center align-items-center bg-light min-vh-100">
          <div className="w-100 p-4 p-md-5" style={{ maxWidth: "500px" }}>
            <div className="bg-white rounded-lg shadow-md p-4 p-md-5">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="text-gray-600 mb-0">
                Please wait while we set things up...
              </p>
            </div>
          </div>
        </div>
      );
    }

    // Error state
    if (onboardingProcessError) {
      return (
        <div className="alert alert-danger mb-0" role="alert">
          {onboardingProcessError}
        </div>
      );
    }

    switch (type) {
      case "onboarding":
        return (
          <div className=" formContainer d-flex justify-content-center align-items-center bg-light min-vh-100">
            <div className="w-100 p-4 p-md-5" style={{ maxWidth: "500px" }}>
              <div className="bg-white rounded-lg shadow-md p-4 p-md-5">
                <div className="text-center mb-4">
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">
                    Welcome! <br /> Let's Set Up Your Payout Account with RoarAI
                  </h2>
                  <p className="text-gray-600 mb-4">
                    To receive your coaching earnings, we'll need to set you up
                    with Stripe, our secure payout provider.
                  </p>
                </div>
                <Button
                  onClick={handleRedirect}
                  disabled={!url}
                  className="btn w-100 saveButton"
                >
                  Set Up Your Payout Account
                </Button>
              </div>
            </div>
          </div>
        );

      case "onetimefee":
        return (
          <div className=" formContainer d-flex justify-content-center align-items-center bg-light min-vh-100">
            <div className="w-100 p-4 p-md-5" style={{ maxWidth: "500px" }}>
              <div className="bg-white rounded-lg shadow-md p-4 p-md-5">
                <div className="text-center mb-4">
                  <h2 className="text-2xl font-bold text-gray-800 mb-3">
                    You're Almost Done! <br /> Complete Your One-Time Fee
                  </h2>
                  <p className="text-gray-600 mb-4">
                    To activate your coaching account with RoarAI, please
                    complete your one-time setup fee. You'll be securely
                    redirected to Stripe to finish your payment.
                  </p>
                </div>
                <Button
                  onClick={handleRedirect}
                  disabled={!url}
                  className="btn w-100 saveButton"
                >
                  Pay Onetime Fee
                </Button>
              </div>
            </div>
          </div>
        );

      case "success":
        return (
          <div className="success-page">
            <div className="success-container">
              <h1 className="success-title">
                🎉 Onboarding Completed Successfully!
              </h1>
              <p className="success-message">
                Thank you for completing the onboarding process. You’re all set
                to get started!
              </p>
              {/* <p className="success-submessage">
                Please click the links below to download the application:
              </p> */}
            </div>
          </div>
        );

      case "failed":
        return (
          <div className="flex justify-center items-center h-screen bg-gray-100">
            <div className="bg-white shadow-lg rounded-2xl p-8 text-center max-w-md">
              <h2 className="text-3xl font-bold text-red-600 mb-4">
                Payment Failed ❌
              </h2>
              <p className="text-gray-700 mb-6">
                Your payment has been failed. Please try again or contact
                support <br /> if you need help.
              </p>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <>
      {/* <div className=" formContainer d-flex justify-content-center align-items-center bg-light min-vh-100">
     <div className="w-100 p-4 p-md-5" style={{ maxWidth: "500px" }}>
     <div className="success-container bg-white rounded-lg shadow-md p-4 p-md-5"> */}
      {renderContent()}
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}
    </>
  );
};

export default StripeCoachOnboard;
